/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, func } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button, Dialog } from '@material-ui/core';

const styles = (theme) => ({
    headerModalText: {
        textAlign: 'center',
        fontWeight: '700',
        marginBottom: '15px',
    },
    alignCenter: {
        textAlign: 'center',
        padding: '15px',
    },
    rootDialog: {
        marginTop: '-55px',
    },
    btnYes: {
        textTransform: 'none',
        backgroundColor: theme.palette.buttonBackgroundColor,
        color: theme.palette.primary?.contrastText,
        fontSize: '1em',
        fontWeight: 'bold',
        margin: '5px',
        width: '120px',
        height: 40,
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.buttonBackgroundColorSecondary,
            color: theme.palette.buttonBackgroundColorSecondary,
        },
    },
    btnNo: {
        textTransform: 'none',
        backgroundColor: theme.palette.white,
        border: `1px solid ${theme.palette.buttonBackgroundColor}`,
        color: theme.palette.buttonBackgroundColor,
        fontSize: '1em',
        fontWeight: 'bold',
        margin: '5px',
        width: '120px',
        height: 40,
        '&:hover, &:focus, &:active': {
            border: `1px solid ${theme.palette.buttonBackgroundColorSecondary}`,
            color: theme.palette.buttonBackgroundColorSecondary,
        },
    },
});

const CloseCalendarConsent = ({
    classes,
    closeModal,
    saveDate,
    closeAreYouSureMessage,
}) => (
    <Dialog
        open
        classes={{
            paper: classes.rootDialog,
        }}
    >
        <div className={classes.alignCenter}>
            <div className={classes.headerModalText}>Would you like to save your delivery date changes?</div>
            <Button
                id="btn-calendar-consent-save"
                name="btnCalendarConsentSave"
                className={classes.btnYes}
                color="primary"
                aria-label="Yes Save date"
                onClick={() => {
                    closeAreYouSureMessage();

                    saveDate();
                }}
            >
                Yes
            </Button>
            <Button
                id="btn-calendar-consent-close"
                name="btnCalendarConsentClose"
                className={classes.btnNo}
                color="primary"
                aria-label="Do not save date"
                onClick={() => {
                    closeAreYouSureMessage();

                    closeModal();
                }}
            >
                No
            </Button>
        </div>
    </Dialog>
);

CloseCalendarConsent.propTypes = {
    classes: object.isRequired,
    closeModal: func.isRequired,
    saveDate: func.isRequired,
    closeAreYouSureMessage: func.isRequired,
};

export default withStyles(styles)(CloseCalendarConsent);
